//Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Components
import Layout from './Layout';
import DashboardMasterAdmin from '../components/DashboardMasterAdmin';
import DashboardAdmin from '../components/DashboardAdmin';
import DashboardEmpresa from '../components/DashboardEmpresa';
import DashboardAvaliador from '../components/DashboardAvaliador';
//Controllers
import PermissaoController, { perfilAcesso } from '../controllers/PermissaoController';

/**
 * Página inicial da aplicação, contendo dashboards personalizados para cada perfil
 */
class DashboardPage extends Component {
    constructor(props) {
        super(props);
        //Controllers
        this.permissaoController = new PermissaoController();
        //Estado inicial
        this.state = {
            carregando: true,
            perfil: 0
        };
    }

    async componentDidMount() {
        //Consulta o perfil do usuário logado
        const perfil = await this.permissaoController.retornarPerfil();
        //Atualiza o status da página
        this.setState({ carregando: false, perfil });
    }

    render() {
        const { onLogout, usuario, empresa, permissoes } = this.props;
        const { carregando, perfil } = this.state;

        return (
            <Layout onLogout={onLogout} usuario={usuario} empresa={empresa} permissoes={permissoes} carregando={carregando} >
                { perfil === perfilAcesso.SUPER_ADMIN && <DashboardMasterAdmin /> }
                { perfil === perfilAcesso.ADMIN && <DashboardAdmin /> }
                { perfil === perfilAcesso.EMPRESA && <DashboardEmpresa /> }
                { perfil === perfilAcesso.AVALIADOR && <DashboardAvaliador /> }
            </Layout>
        );
    }

}

DashboardPage.propTypes = {
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired
};

export default DashboardPage;